import { Navigate, createBrowserRouter } from "react-router-dom";

import AccountDeletionPage from "@/routes/account-deletion-page";
import CheckoutPage from "@/routes/auth/inscription/checkout-page";
import RegisterPage from "@/routes/auth/inscription/register-page";
import SubscriptionPage from "@/routes/auth/inscription/subscription-page";
import SuccessPage from "@/routes/auth/inscription/success";
import LoginLayout from "@/routes/auth/login-layout";
import LoginPage from "@/routes/auth/login-page";
import ForgotPasswordEmailPage from "@/routes/auth/mot-de-passe-oublie/email/forgot-password-email-page";
import ForgotPasswordPage from "@/routes/auth/mot-de-passe-oublie/forgot-password-page";
import ResetPasswordPage from "@/routes/auth/reset-mot-de-passe/[code]/[email]/reset-password-page";
import ResetPasswordSuccessPage from "@/routes/auth/reset-mot-de-passe/success/reset-password-success-page";
import DashboardPage from "@/routes/dashboard/dashboard-page";
import Layout from "@/routes/layout/layout";
import PatientPage from "@/routes/patients/[id]/patient-page";
import PatientFormPage from "@/routes/patients/fiche/patient-form-page";
import PrivacyPolicyPage from "@/routes/privacy-policy-page";
import ProfilePage from "@/routes/profile/profile-page";

const routerNotAuthenticated = createBrowserRouter([
  {
    path: "/",
    element: <LoginLayout />,
    children: [
      {
        path: "",
        element: <Navigate to="/connexion" replace />,
      },
      {
        path: "/connexion",
        element: <LoginPage />,
      },
      {
        path: "/mot-de-passe-oublie",
        element: <ForgotPasswordPage />,
      },
      {
        path: "/mot-de-passe-oublie/email",
        element: <ForgotPasswordEmailPage />,
      },
      {
        path: "/reset-mot-de-passe/:code/:email",
        element: <ResetPasswordPage />,
      },
      {
        path: "/reset-mot-de-passe/success",
        element: <ResetPasswordSuccessPage />,
      },
      {
        path: "/inscription",
        element: <RegisterPage />,
      },
      {
        path: "/account-deletion",
        element: <AccountDeletionPage />,
      },
    ],
  },
  {
    path: "/subscription",
    element: <SubscriptionPage />,
  },
  {
    path: "/checkout",
    element: <CheckoutPage />,
  },
  {
    path: "/success",
    element: <SuccessPage />,
  },
  {
    path: "/privacy-policy",
    element: <PrivacyPolicyPage />,
  },
  {
    path: "*",
    element: <Navigate to="/connexion" />,
  },
]);

const router = createBrowserRouter([
  {
    path: "/",
    element: <Layout />,
    children: [
      {
        path: "",
        element: <Navigate to="/dashboard" replace />,
      },
      {
        path: "/dashboard",
        element: <DashboardPage />,
      },
      { path: "/patients/:id", element: <PatientPage /> },
      { path: "/patients/fiche", element: <PatientFormPage /> },
      { path: "/profile", element: <ProfilePage /> },
      { path: "/privacy-policy", element: <PrivacyPolicyPage /> },
      { path: "/account-deletion", element: <AccountDeletionPage /> },
    ],
  },
  {
    path: "*",
    element: <Navigate to="/dashboard" replace />,
  },
]);

export { router, routerNotAuthenticated };
